module.exports = __webpack_public_path__ + "bg-photo-desktop.webp?579450c8c173d50837dc5ce179cf2013";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-photo-desktop.webp
// module id = 200
// module chunks = 0